import { useMemo } from 'react'

import type { OfferingDto } from '@b-stock/offering-api-client'

import useAccountId from '@/buyer-portal/helpers/useAccountId'

export const useIsSellerUserOfferingOwner = ({
  offering,
}: {
  offering: OfferingDto | null
}) => {
  const accountId = useAccountId()

  return useMemo(
    () => accountId === offering?.accountId,
    [accountId, offering?.accountId]
  )
}
